import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HubNotification, HubNotificationStatus } from '@core/interfaces/notification';
import { Pagination } from '@core/interfaces/pagination';
import { environment } from '@env';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private httpClient = inject(HttpClient);

  private readonly baseUrl = `${environment.NOTIFICATION_SERVICE_URL}/api/v1/notifications`;

  all(pagination?: Pagination): Observable<HubNotification[]> {
    let params = new HttpParams();
    if (pagination?.limit !== undefined && pagination?.limit !== null) {
      params = params.set('limit', pagination.limit.toString());
    }

    if (pagination?.offset !== undefined && pagination?.offset !== null) {
      params = params.set('offset', pagination.offset.toString());
    }

    return this.httpClient.get<HubNotification[]>(this.baseUrl, { params });
  }

  markAsRead(notificationId: string): Observable<HubNotification> {
    return this.httpClient.put<HubNotification>(`${this.baseUrl}/${notificationId}/status`, {
      status: HubNotificationStatus.READ,
    });
  }
}
